module.exports = __webpack_public_path__ + "static/media/samanthacheung.a727ea80.jpeg";